<div class="flex flex-col items-center text-center w-full">
    <img
        class="h-[180px] max-[600px]:h-[140px] w-auto mb-4"
        src="./assets/images/modal-freetrial-ended.svg"
        alt="" />

    <h2 class="font-semibold text-[#231F20] text-2xl max-[600px]:text-xl leading-[1.3] mb-2.5">
        {{ data.title | translate }}
    </h2>

    <div class="text-[#374151] text-base max-[600px]:text-[15px] leading-[1.6] max-w-[440px]">
        <p class="m-0">{{ data.message | translate }}</p>
    </div>

    <!-- Packages available -->
    <div class="w-full mt-5">
        <div
            class="text-xs font-semibold tracking-[0.5px] uppercase text-[#94A3B8] text-center mb-2.5">
            {{ 'askPodPopup.trialEndedPackagesLabel' | translate }}
        </div>

        <div class="flex flex-col w-full border-[1.5px] border-[#E2E8F0] rounded-[14px] overflow-hidden">
            <!-- Loading -->
            <div
                *ngIf="loading"
                class="py-4 px-5 text-sm text-[#5F5B5B] text-center">
                {{ 'askPodPopup.trialEndedLoading' | translate }}
            </div>

            <!-- Empty / failed to load -->
            <div
                *ngIf="!loading && packages.length === 0"
                class="py-4 px-5 text-sm text-[#5F5B5B] text-center">
                {{ 'askPodPopup.trialEndedEmpty' | translate }}
            </div>

            <!-- Paid packages (cheapest first, highest priced tagged "Best Value") -->
            <ng-container *ngFor="let pkg of packages; let first = first">
                <div *ngIf="!first" class="h-px w-full bg-[#E2E8F0] shrink-0"></div>

                <div
                    class="flex items-center justify-between text-left py-4 px-5 max-[600px]:py-3.5 max-[600px]:px-4"
                    [ngClass]="pkg.isBestValue ? 'bg-gradient-to-br from-[#41c8f712] to-[#6774f812]' : ''">
                    <div class="flex flex-col">
                        <span
                            *ngIf="pkg.isBestValue"
                            class="self-start inline-block bg-gradient-to-br from-[#41C8F7] to-[#6774F8] text-white text-[9px] font-bold tracking-[0.4px] leading-none py-[3px] px-2.5 rounded-full uppercase mb-1.5">
                            {{ 'askPodPopup.trialEndedBestValue' | translate }}
                        </span>
                        <div class="font-bold text-[15px] max-[600px]:text-sm text-[#231F20] mb-0.5">
                            {{ pkg.addonCode | titlecase }}
                        </div>
                        <div
                            class="trial-pkg-credits text-sm max-[600px]:text-[13px] text-[#5F5B5B]"
                            [innerHTML]="'askPodPopup.trialEndedCreditsPerDay' | translate: { count: pkg.dailyCredits }"></div>
                    </div>
                    <div class="font-bold text-xl max-[600px]:text-lg text-[#231F20] leading-none text-right">
                        <ng-container *ngIf="pkg.price != null; else noPrice">
                            RM{{ pkg.price | number: '1.0-0' }}
                            <span class="block text-[11px] font-normal text-[#8A8A8A] mt-[3px]">
                                {{ 'askPodPopup.trialEndedPerYear' | translate }}
                            </span>
                        </ng-container>
                        <ng-template #noPrice>-</ng-template>
                    </div>
                </div>
            </ng-container>
        </div>

        <!-- Sales note -->
        <div class="flex items-start gap-1.5 mt-2.5 text-left">
            <svg
                class="w-[13px] h-[13px] shrink-0 text-[#8A929C] mt-0.5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
            <span class="text-xs text-[#8A929C] leading-[1.5]">
                {{ 'askPodPopup.trialEndedNote' | translate }}
            </span>
        </div>
    </div>

    <!-- Footer -->
    <div class="flex flex-col items-center gap-4 w-full mt-7">
        <button
            type="button"
            class="bg-[#00AFED] text-white border-none rounded-[10px] py-3 px-6 min-w-[120px] font-semibold text-base leading-[normal] cursor-pointer transition-colors hover:bg-[#009AD6] max-[600px]:w-full"
            [mat-dialog-close]="false">
            {{ 'button.close' | translate }}
        </button>
    </div>
</div>
